:host {
  --row-background-color: var(--grid-row-background-color);
  --row-border-color: var(--chart-101-pressed-dividers);
  --cell-padding: 0 var(--spacer);
  --column-max-width: 400px;
  --footer-height: fit-content;
  --footer-border-bottom: 1px solid var(--chart-100-pressed);
  position: relative;
  z-index: 1;
}

:host([disabled]) .disable-interaction {
  display: block;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

vaadin-grid-cell-content {
  padding: var(--cell-padding);
  overflow: visible;
}

gz-tooltip {
  pointer-events: inherit;
}

.cell-label {
  display: block;
  width: 100%;
  color: var(--body-text-arrows-400);
  font-size: var(--body-size-medium);
  --font-family: var(--font-family-secondary);

  &--header {
    --font-family: 'Montserrat', sans-serif;;
    font-size: var(--body-size);
  }
}

.copy-cell-content {
  display: flex;
  align-items: center;
  min-width: 0;
}

.action-icon {
  &:hover {
    background-color: var(--chart-050-hover);
    border-radius: 4px;
  }
}

.action-btn-tooltip {
  height: 24px;
}

vaadin-grid {
  background-color: var(--grid-row-hover-background);
}

.actions-cell {
  display: flex;
  gap: var(--spacer);
  align-items: center;
}

.default-icon {
  height: calc(var(--spacer) * 3);
}

.loading-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  gz-loader {
    padding: calc(var(--spacer) * 0.5) 0;
    border-bottom: 1px solid var(--row-border-color);
  }
}
